import { render, staticRenderFns } from "./CallsignAwards.vue?vue&type=template&id=f88c52cc&"
import script from "./CallsignAwards.vue?vue&type=script&lang=js&"
export * from "./CallsignAwards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports